import { SUPPORTED_SUBFLOWS } from '@withdrawals/constants'
import { getFlowPath } from '@withdrawals/helpers/getFlowPath'
import type { ExtendedSubFlow } from '@withdrawals/types'
import { tr } from 'mmfintech-commons'

export const findSupportedSubFlow = (subFlow: ExtendedSubFlow) => {
  const flow = SUPPORTED_SUBFLOWS.find(entry => entry.key === subFlow)
  return flow
    ? {
        paymentMethod: flow.key,
        title: flow.titleKey ? tr(flow.titleKey, flow.title) : flow.title,
        description: flow.descriptionKey ? tr(flow.descriptionKey, flow.description) : flow.description,
        dataTest: flow.dataTest,
        path: flow.path ?? getFlowPath(flow.key)
      }
    : null
}
